import { jsx } from 'react/jsx-runtime';
import { useMemo } from 'react';
import { HeadingContext } from './context.es.js';

/**
 * Heading Provider.
 */ const HeadingProvider = (props)=>{
    const { children, ...rest } = props;
    // Memoized provider value.
    const values = useMemo(()=>({
            ...rest
        }), [
        rest
    ]);
    return jsx(HeadingContext.Provider, {
        value: values,
        children: children
    });
};

export { HeadingProvider };
//# sourceMappingURL=provider.es.js.map
